import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { curationsApiPath } from './apiPath';

const CurationV2TypeSchema = z.enum(['GOODS', 'SNAP2']).describe('CurationV2TypeSchema');

/** OpenAPI `CreateCurationV2Request` */
const PostCurationsRequestSchema = z
  .object({
    title: z.string().min(0).max(25),
    description: z.string().min(0).max(25).optional(),
    type: CurationV2TypeSchema.optional(),
    goodsNoList: z.array(z.number()).min(0).max(100),
    snapIdList: z.array(z.string()).min(0).max(100),
  })
  .describe('PostCurationsRequestSchema');

export type PostCurationsRequest = z.infer<typeof PostCurationsRequestSchema>;

/** OpenAPI `POST /v2/curations` 200 `data` — 필드명은 생성 응답만 `count`(수정 응답은 `goodsCount`). */
const PostCurationsResponseDataSchema = z
  .object({
    curationId: z.union([z.string(), z.number()]),
    title: z.string(),
    description: z.string().optional(),
    count: z.number(),
  })
  .describe('PostCurationsResponseDataSchema');

const PostCurationsResponseSchema = createApiResponseSchema(PostCurationsResponseDataSchema);

type PostCurationsResponse = z.infer<typeof PostCurationsResponseSchema>;

/** POST `/v2/curations` — 플랫폼은 `x-platform` 헤더(httpClient)로 전달. */
export const postCurations = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PostCurationsRequestSchema),
    async (params: PostCurationsRequest) =>
      executeStandardRequest(async () => {
        const response = await privateHttpClient.post<PostCurationsResponse>(
          urlJoin(curationsApiPath.postCurations),
          params,
        );
        return response;
      }),
    validateApiResponse(PostCurationsResponseSchema),
  ),
);
